import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators';

import { RangeSliderComponent } from '../../range-slider-component';
import topicData from '../../../helpers/state/topic-data';

@customElement('map-orientation')
export class RotationTilt extends LitElement {

	@property({ type: Boolean })
    open: boolean = false;

	async onChangeRotation(e: Event) {
		const rotation = (e.target as RangeSliderComponent).value;

		if (topicData.mapComponent) {
			topicData.mapComponent.rotateMap(rotation);
		}

		await topicData.fetchAndUpdateTopicData({
			default_map_rotation: rotation
		}, 'default_map_rotation');
	}

	async onChangeTilt(e: Event) {
		let tilt = (e.target as RangeSliderComponent).value;

		if (topicData.mapComponent) {
			topicData.mapComponent.tiltMap(tilt);
			tilt = topicData.mapComponent.googleMapComponent.map.getTilt();
		}

		// round to nearest integer
		tilt = Math.round(tilt);

		await topicData.fetchAndUpdateTopicData({
			default_map_tilt: tilt
		}, 'default_map_tilt');
	}

	async onChangeZoom(e: Event) {
		const zoom = (e.target as RangeSliderComponent).value;

		if (topicData.mapComponent) {
			topicData.mapComponent.googleMapComponent.map.setZoom(zoom);
			topicData.mapComponent.showSetDefaultZoomCenter = false;
		}

		await topicData.fetchAndUpdateTopicData({
			default_map_zoom: zoom
		}, 'default_map_zoom');
	}

    render() {

        return html`
			<h4 class="header-colors-label">
                Orientation
            </h4>
			<div style="color: grey; margin-bottom: 10px;">
			*Rotation and Tilt may be limited by the map style.<br>
			*Adjust the default <b>map center</b> by dragging the map to the desired spot thne click yellow "Set as New Default View" button at the bottom of the map.
			${topicData.topic?.custom_overlays && topicData.topic?.custom_overlays.length > 0 ? html`
				<br>*You cannot tilt the map when custom overlays are present.
			` : ''}
			</div>
			<div class="color__wrapper">
				<div class="slider_holder">
					<span style="display: flex; align-items: center; flex-direction: row;">
						Zoom
					</span>
					<range-slider-component
						minString="World"
						maxString="Street"
						min=${1}
						max=${20}
						step=${1}
						unit=${''}
						.value=${topicData.topic?.default_map_zoom ?? 4}
						@change=${this.onChangeZoom}
					></range-slider-component>
				</div>
				<div class="slider_holder">
					<span> Rotation </span>
					<range-slider-component
						minString="0"
						maxString="360"
						min=${0}
						max=${360}
						step=${1}
						unit=${'deg'}
						.value=${topicData.topic?.default_map_rotation ?? 0}
						@change=${this.onChangeRotation}
					></range-slider-component>
				</div>
				${topicData.topic?.custom_overlays && topicData.topic?.custom_overlays.length > 0 ? '' : html`
					<div class="slider_holder">
						<span style="display: flex; align-items: center; flex-direction: row;">
							Tilt
							<form-tooltip
								tipwidth="180px"
								leftPadding="30%"
								message="The tilt available is limited by the map style and the zoom level."
								>
								<mwc-icon>info_outline</mwc-icon>
							</form-tooltip>
						</span>
						<range-slider-component
							minString="0"
							maxString="67"
							min=${0}
							max=${67}
							step=${1}
							unit=${'deg'}
							.value=${topicData.topic?.default_map_tilt ?? 0}
							@change=${this.onChangeTilt}
						></range-slider-component>
					</div>
				`}
			</div>
		`;
    }

    static get styles() {
        return css`
		    .input {
                width: 100%;
                padding: auto 5px;
            }

			range-slider-component {
				width: 100%;
			}

			mwc-icon {
				--mdc-icon-size: .8rem;
				color: grey;
			}

			.slider_holder {
				display: flex;
				flex-direction: column;
				align-items: flex-start;
				gap: 10px;
				flex: 1;
			}

			.color__wrapper {
				display: flex;
				flex-direction: row;
				align-items: center;
				gap: 20px;
			}

			.header-colors-label {
                margin: 10px 0;
            }

			@media (max-width: 600px) {
				.color__wrapper {
					flex-direction: column;
				}
			}
        `;
    }
}
